import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { formatPhoneNumber } from "../../utils/phoneUtils";
export const RepeatCallers = ({ repeatCallers, selectedOutcome }) => {
    return (_jsxs("div", { children: [_jsxs("h6", { className: "fs-14 ps-blue m-0 mb-10 fw-600", children: ["Repeat Callers with ", selectedOutcome, " (5+ Total Calls, No Agent Interactions)"] }), _jsx("div", { className: "bg-gray-100 rounded-8 border border-gray-300 overflow-auto", style: {
                    padding: "20px",
                    minHeight: "60px",
                    fontSize: "14px",
                }, children: repeatCallers.length === 0 ? (_jsx("div", { className: "text-muted fs-14 text-center font-italic", style: { padding: "20px 0" }, children: "No repeat callers found" })) : (repeatCallers.map((caller, index) => (_jsxs("div", { className: "d-flex justify-content-between align-items-center", style: {
                        gap: "8px",
                        padding: "12px 16px",
                        marginBottom: index < repeatCallers.length - 1 ? "8px" : "0",
                        backgroundColor: "white",
                        borderRadius: "6px",
                        border: "1px solid #dee2e6",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    }, children: [_jsx("span", { className: "fs-14 ps-blue fw-500", children: formatPhoneNumber(caller.phoneNumber) }), _jsxs("span", { className: "fs-12 fw-600", style: {
                                backgroundColor: "#3b82f6",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "12px",
                                minWidth: "60px",
                                textAlign: "center",
                            }, children: [caller.count, " calls"] })] }, caller.phoneNumber)))) })] }));
};
export default RepeatCallers;
//# sourceMappingURL=RepeatCallers.js.map